import { useState } from 'react';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { useShallow } from 'zustand/shallow';
import Center from '../../assets/styles/Center';
import FormContainer from '../../assets/styles/FormContainer';
import FormAuth from '../../components/FormAuth';
import GroupInput from '../../components/GroupInput';
import Title from '../../components/Title';
import Verification from '../../components/Verification';
import useErrors from '../../hooks/useErrors';
import UserService from '../../services/UsersService';
import { useStore } from '../../stores';

export default function V5() {
  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const { userData, login } = useStore(
    useShallow((state) => ({
      userData: state.userData,
      login: state.login,
    }))
  );

  const { setError, removeError, getErrorMessageByFieldName, errors } =
    useErrors();

  const navigate = useNavigate();

  function handlePassword(e) {
    setPassword(e.target.value);

    removeError('password');
  }

  function handleConfirmPassword(e) {
    setConfirmPassword(e.target.value);

    if (e.target.value !== password) {
      setError({
        field: 'confirmPassword',
        message: 'As senha não coincidem',
      });
    } else {
      removeError('confirmPassword');
    }
  }

  async function onSubmit() {
    try {
      setLoading(true);

      if (!password) {
        setError({ field: 'password', message: 'A senha é obrigátoria' });
        throw new Error('A senha está vazia');
      }

      const { email, phone, cpf, numberAccept, emailAccept } = userData;

      const body = {
        email,
        password,
        type: 'model',
        cpf: cpf.replace(/\D/g, ''),
        phone,
        numberAccept,
        emailAccept,
      };

      const { token, user } = await UserService.register(body);

      const bodyLogin = {
        token,
        id: user.id,
        email: user.email,
        type: user.type,
      };

      login(bodyLogin);

      navigate('/modelrequired');
    } catch (error) {
      toast.error(error.message || 'Erro ao criar conta!');
    } finally {
      setLoading(false);
    }
  }

  const isFormValid =
    Boolean(password && confirmPassword) && errors.length === 0;

  return (
    <FormContainer>
      <Center className="center">
        <Verification v={5} />

        <Title title="Crie sua senha" subtitle="Faça uma senha forte" />

        <FormAuth
          onSubmit={onSubmit}
          buttonTitle="Criar conta"
          isLoading={loading}
          formValid={isFormValid}
        >
          <GroupInput password error={getErrorMessageByFieldName('password')}>
            <label>Senha*</label>
            <input
              type="text"
              placeholder="Digite seu código"
              value={password}
              onChange={handlePassword}
            />
          </GroupInput>

          <GroupInput
            password
            error={getErrorMessageByFieldName('confirmPassword')}
          >
            <label>Confirme a senha*</label>
            <input
              type="text"
              placeholder="Digite seu código"
              value={confirmPassword}
              onChange={handleConfirmPassword}
            />
          </GroupInput>
        </FormAuth>
      </Center>
    </FormContainer>
  );
}
